<template>
  <div class="pastRecords">
    <div class="time-range" v-if="ISshow">
      <el-select
        v-model="value"
        placeholder="最近1个月"
        size="small"
        @change="TimeRangeSearch"
      >
        <el-option
          v-for="item in options"
          :key="item.label"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div v-if="ISshow" class="pastRecordsmain">
      <div class="item">
        <div class="list pointer" v-for="(item, index) in info" :key="index">
          <div class="tit">
            <!-- <span class="fl">{{
              item.billCategory == "02"
                ? "增值税普通发票"
                : item.billCategory == "01" 
                ? "增值税专用发票"
                : item.billCategory == "06"
                ? "增值税电子发票"
                : item.billCategory == "03"
                ? "定额发票"
                : item.billCategory == "05"
                ? "通用机打"
                : item.billCategory == "07"
                ? "增值税电子专用发票"
                : ""
            }}</span> -->
            <span class="fl">{{
              item.billCategory == "02"
                ? "增值税普通发票"
                : item.billCategory == "01" 
                ? "增值税专用发票(纸质发票)"
                : item.billCategory == "06" || item.billCategory == "14"
                ? "增值税电子发票"
                : item.billCategory == "03"
                ? "定额发票"
                : item.billCategory == "05"
                ? "通用机打"
                : item.billCategory == "07"
                ? "增值税电子专用发票"
                : item.billCategory == "13"
                ? "增值税专用发票(电子发票)"
                :""
            }}</span>
            <span class="fr">¥{{ item.billAmount || "-" }}</span>
          </div>
          <div class="splitLine"></div>
          <div class="row">
            <span class="text1">发票抬头：</span>
            <span class="name" :title="item.acceptTinName">{{
              item.acceptTinName || "-"
            }}</span>
          </div>
          <div class="row">
            <span class="text1">税号：</span>
            <span class="name" :title="item.acceptTinCode">{{
              item.acceptTinCode || "-"
            }}</span>
          </div>
          <div class="row">
            <span class="text1">发票号码：</span>
            <span>{{ item.billNo || "-" }}</span>
          </div>
          <div class="row">
            <span class="text1">发票代码：</span>
            <span>{{ item.billCode || "-" }}</span>
          </div>
          <div class="row">
            <span class="text1">申请日期：</span>
            <span>{{ item.applyTime || "." }}</span>
            <!-- v-if="item.status =='24'" -->
            <!-- <div class="box" ><span style="color: #FF0000;">开具失败</span></div> -->
            <div
              class="box"
              v-if="
                item.status != '7' &&
                item.status != '31' &&
                item.status != '3' &&
                item.status != '15' &&
                item.status != '24' &&
                item.status != '4' &&
                item.status != '6'
              "
              style="background: rgba(158, 82, 10, 0.12)"
            >
              <span style="color: #9e520a">{{
                item.status == "0"
                  ? "待受理"
                  : item.status == "1"
                  ? "待审核"
                  : item.status == "2"
                  ? "不通过"
                  : item.status == "3"
                  ? "待开具"
                  : item.status == "5"
                  ? "已寄送"
                  : item.status == "6"
                  ? "已作废"
                  : item.status == "8"
                  ? "删除"
                  : item.status == "9"
                  ? "系统删除"
                  : item.status == "14"
                  ? "开具中"
                  : item.status == "17"
                  ? "作废中"
                  : item.status == "18"
                  ? "删除中"
                  : item.status == "15"
                  ? "寄送中"
                  : item.status == "16"
                  ? "作废中"
                  : item.status == "26"
                  ? "作废失败"
                  : item.status == "24"
                  ? "开具失败"
                  : item.status == "27"
                  ? "作废失败"
                  : item.status == "28"
                  ? "删除失败"
                  : item.status == "25"
                  ? "寄送失败"
                  : item.status == "32"
                  ? "待回收发票"
                  : ""
              }}</span>
            </div>
            <div
              class="box"
              v-if="item.status == '15'"
              style="background: rgba(158, 82, 10, 0.12)"
            >
              <span style="color: #9e520a">寄送中</span>
            </div>
            <div
              class="box"
              v-if="item.status == '3'"
              style="background: rgba(158, 82, 10, 0.12)"
            >
              <span style="color: #9e520a">待开具</span>
            </div>
            <div
              class="box"
              v-if="item.status == '31'"
              style="background: rgba(158, 82, 10, 0.12)"
            >
              <span style="color: #9e520a">已撤销</span>
            </div>
            <div class="box" v-if="item.status == '24'">
              <span style="color: #ff0000">开具失败</span>
            </div>
          </div>
          <div class="rowbut">
            <span
              class="buttext"
              @click="Invoicing(item.elecLinkAdress)"
              v-if="
                (item.billCategory == '01' || item.billCategory == '02') &&
                (item.status == '4' ||
                  item.status == '6' ||
                  item.status == '16' ||
                  item.status == '26' ||
                  item.status == '5' ||
                  item.status == '15' ||
                  item.status == '25' ||
                  item.status == '7' ||
                  item.status == '17' ||
                  item.status == '27')
              "
              >查看发票</span
            >
             <!-- <span
              class="buttext"
              @click="Invoicing(item.elecLinkAdress)"
              v-if="
                item.billCategory == '06' &&
                (item.status == '4' ||
                  item.status == '7' ||
                  item.status == '17' ||
                  item.status == '27' ||
                  item.status == '5')
              "
              >查看发票</span
            > -->

             <span
              class="buttext"
              @click="Invoicing(item.elecLinkAdress)"
              v-if="
                (item.billCategory == '06' || item.billCategory == '13' || item.billCategory == '14') &&
                (item.status == '4' ||
                  item.status == '7' ||
                  item.status == '17' ||
                  item.status == '27' ||
                  item.status == '5')
              "
              >查看发票</span
            >
           
            <el-popconfirm
              title="确认要撤销该发票吗？"
              v-if="
                (item.billCategory == '01' || item.billCategory == '02') &&
                (item.status == '0' || item.status == '1' || item.status == '3')
              "
              @confirm="changeButton('撤销', item)"
            >
              <div class="buttext" slot="reference">撤销发票</div>
            </el-popconfirm>
            <!-- <el-popover
              v-if="item.billCategory == '06' && item.status == '4'"
              placement="bottom"
              trigger="click"
            >
              <div>
                <h4 style="color: #000">再次发送</h4>
                <div class="df" style="margin: 12px 0 20px 0">
                  <span style="width: 120px; line-height: 32px"
                    >收票人邮箱：</span
                  >
                  <el-input
                    size="small"
                    v-model="email"
                    placeholder="请输入邮箱"
                  ></el-input>
                </div>
                <div style="text-align: right; margin: 0">
                  <el-button
                    type="primary"
                    size="small"
                    slot="reference"
                    @click="confirmPay(item, index)"
                    >再次发送
                  </el-button>
                </div>
              </div>
              <div class="buttext" slot="reference">发送邮件</div>
            </el-popover> -->
            <div v-if="item.billCategory == '06' || item.billCategory == '13' || item.billCategory == '14'">
              <!-- 发送邮箱 -->
              <el-popover
                v-if="item.status == '4'"
                placement="bottom"
                trigger="manual"
                v-model="visible"
              >
                <div>
                  <h4 style="color: #000">再次发送</h4>
                  <div class="df" style="margin: 12px 0 20px 0">
                    <span style="width: 120px; line-height: 32px"
                      >收票人邮箱：</span
                    >
                    <el-input
                      size="small"
                      v-model="email"
                      placeholder="请输入邮箱"
                    ></el-input>
                  </div>
                  <div style="text-align: right; margin: 0">
                    <el-button
                      size="small"
                      slot="reference"
                      @click="visible = false"
                      >暂不发送</el-button
                    >
                    <el-button
                      type="primary"
                      size="small"
                      slot="reference"
                      @click="confirmPay(item, index)"
                      >再次发送</el-button
                    >
                  </div>
                </div>
                <div
                  class="buttext"
                  slot="reference"
                  @click="visible = !visible"
                >
                  发送邮件
                </div>
              </el-popover>
            </div>
            <!-- <span class="buttext"></span> -->
            <el-popover
              placement="top-start"
              width="100"
              trigger="hover"
              :content="item.expressNo ? item.expressNo : '暂无寄送单号'"
              v-if="
                (item.billCategory == '01' || item.billCategory == '02') &&
                item.status == '5'
              "
            >
              <div class="buttext" slot="reference">查看物流</div>
            </el-popover>
            <el-popover
              placement="top-start"
              width="100"
              trigger="hover"
              :content="statePersonPhone"
              v-if="
                item.status == '14' ||
                item.status == '24' ||
                item.status == '16' ||
                item.status == '26' ||
                item.status == '18' ||
                item.status == '28' ||
                item.status == '17' ||
                item.status == '27'
              "
            >
              <div class="buttext" slot="reference">联系会计</div>
            </el-popover>
            <el-popconfirm
              title="确认要作废该发票吗？"
              v-if="(item.billCategory == '06' || item.billCategory == '14' ||item.billCategory == '13') && item.status == '4'"
              @confirm="changeButton('作废', item)"
            >
              <div class="buttext" slot="reference">作废</div>
            </el-popconfirm>
            <el-popover placement="top-start" width="200" trigger="click">
              <el-card class="box-card" shadow="never">
                <div v-for="o in viewBillList" :key="o" class="text item">
                  {{ o }}
                </div>
              </el-card>
              <div
                class="buttext"
                slot="reference"
                @click="viewBill(item.applyNo)"
              >
                查看账单
              </div>
            </el-popover>
          </div>
          <img
            v-if="item.status == '4'"
            class="Open-according-to"
            src="../../../assets/Open-according-to.png"
            alt=""
          />
          <img
            v-if="item.status == '6'"
            class="Open-according-to"
            src="../../../assets/picture/cancellation.png"
            alt=""
          />
          <!-- <img
            v-if="item.status =='31'"
            class="Open-according-to"
            src="../../../assets/picture/send-back.png"
            alt="" -->
          <!-- /> -->
          <img
            v-if="item.status == '7'"
            class="Open-according-to"
            src="../../../assets/picture/cancellation.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <div class="bottom fl" v-if="total > 8">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currpage"
        :page-sizes="[8, 16, 32]"
        :page-size="pagesize"
        layout="total,prev, pager, next, sizes,jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <noContent
      style="padding-top: 100px; text-align: center"
      v-if="!ISshow"
      img="1"
      explain="还没有开票记录，可在待开发票中进行开票"
    ></noContent>

    <!-- <el-dialog
      title="增值税专用发票-发票预览-(预览发票仅供参考)"
      :visible.sync="visible"
      width="70%"
    >
      <Tableinvoice :obj="InvoicePreviewList" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="visible = false">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import API from "../../../api/invoice";
import noContent from "@/components/noContent";
// import Tableinvoice from "@/components/Tableinvoice";

const api = new API();
export default {
  components: { noContent },
  data() {
    return {
      email: "",
      total: 0,
      timeRange: "1",
      pagesize: 8, //每页的数据条数
      currpage: 1, //默认开始页面
      value: "",
      statePersonPhone: "",
      InvoicePreviewList: {},
      viewBillList: [],
      options: [
        { value: "1", label: "最近1个月" },
        { value: "3", label: "最近3个月" },
        { value: "6", label: "最近半年" },
        { value: "12", label: "最近1年" },
      ],

      visible: false,
      ISshow: true,

      info: [],
    };
  },
  methods: {
    // 再次发送邮箱
    confirmPay(item, index) {
      this.sendInvoceEmail(item, index);
    },
    // 再次发送邮箱请求
    async sendInvoceEmail(item, index) {
      console.log(item);
      let parme = {
        createTime: item.createDate + "",
        applyNo: item.applyNo,
        emailAddress: this.email,
        elecLinkAdress: item.elecLinkAdress,
      };
      let res = await api.sendInvoceEmail(parme);
      this.info[index].sends = false;
      this.visible = false;
      this.$message({
        showClose: true,
        message: res,
        type: "success",
        offset: 300,
      });
    },
    // 按照时间段搜索待開發票
    TimeRangeSearch(value) {
      this.currpage = 1;
      this.pageSize = 8;
      this.timeRange = value;
      this.queryApplyedInvocieListByparms();
    },
    async Invoicing(item) {
      console.log(item);
      if (item !== undefined) {
        window.open(item);
      } else {
        this.$message.error("该发票暂无PDF链接请稍后再试");
      }
    },
    async viewBill(item) {
      let res = await api.queryStaatBillNoByApplyNO({ applyNo: item });
      this.viewBillList = res.data;
      return res.data;
    },
    // 分页 : 选择展示条数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pagesize = val;
      this.currpage = 1;
      this.queryApplyedInvocieListByparms();
    },
    async changeButton(name, item) {
      let res;
      let parmas = {};
      switch (name) {
        case "撤销":
          parmas = {
            applyNo: item.applyNo,
            startDate: this.$moment(item.createDate).format("YYYY-MM-DD"),
          };
          console.log(item);
          res = await api.cancelInvoiceApply(parmas);
          if (res.success) {
            this.$message({
              message: "撤销成功",
              type: "success",
            });
          } else {
            this.$message.error(res.errorMsg);
          }
          this.queryApplyedInvocieListByparms();
          this.$forceUpdate();
          break;
        case "作废":
          parmas = {
            applyNo: item.applyNo,
            applicantCode: item.applicantCode,
          };
          res = await api.invoiceToRed(parmas);
          console.log(res);
          if (res.success) {
            this.$message({
              message: "作废成功",
              type: "success",
            });
          } else {
            this.$message.error(res.errorMessage);
          }
          this.queryApplyedInvocieListByparms();
          this.$forceUpdate();
          break;
      }
    },
    // 分页 : 换页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currpage = val;
      this.queryApplyedInvocieListByparms();
    },
    //数据请求
    async queryApplyedInvocieListByparms() {
      let parme = {
        invoiceMonth: +this.timeRange,
        currentPage: this.currpage,
        pageSize: this.pagesize,
      };
      let res = await api.queryApplyedInvocieListByparms(parme);
      console.log(res);
      if (res.dataList) {
        this.info = JSON.parse(JSON.stringify(res.dataList));
        this.total = res.total;
        this.statePersonPhone = res.statePersonPhone;
        this.info.forEach((item) => {
          item.sends = false;
          item.billStartDetail = this.$moment(item.billStartDetail).format(
            "YYYY-MM-DD"
          );
          item.billEndDetail = this.$moment(item.billEndDetail).format(
            "YYYY-MM-DD"
          );
          item.applyTime = this.$moment(item.applyTime).format("YYYY-MM-DD");
        });
        this.ISshow = true;
      } else {
        this.ISshow = false;
        this.info = [];
      }

      console.log(this.info);
      if (res) {
        // this.mailbox = res[0]
      }
    },
  },
  created() {
    this.queryApplyedInvocieListByparms();
  },
};
</script>

<style lang='less' scoped>
.box-card {
  width: 180px;
  height: 100px;
  padding: 0;
  overflow-y: auto;
}
.pastRecords {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
  .box {
    // width: 72px;
    padding: 0px 15px;
    height: 24px;
    background: rgba(221, 65, 65, 0.12);
    border-radius: 12px;
    text-align: center;
    position: absolute;
    right: 24px;
    span {
      // width: 56px;
      height: 20px;
      font-size: 14px;
      font-weight: 600;
      line-height: 24px;
    }
  }

  .time-range {
    margin-bottom: 24px;
  }
  .pastRecordsmain {
    flex: 1;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background-color: rgba(0, 1, 0, 0);
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      border-radius: 8px;
    }
    .item {
      overflow: auto;
      display: flex;
      flex-wrap: wrap;
    }
    .list {
      max-width: 360px;
      position: relative;
      width: 23.5%;
      height: 280px;
      text-align: left;
      border: 1px solid #ecececff;
      border-radius: 4px;
      background-color: #fff;
      padding: 24px;
      margin: 0 0 32px 0;
      margin-right: 2%;
      // position: relative;
      // .display {
      //   position: absolute;
      //   bottom: 0;
      //   background-color: pink;
      //   height: 50px;

      // }
      .tit {
        font-size: 16px;
        font-weight: 500;
        color: #9e520a;
        height: 24px;
        margin: 0;
      }
      .splitLine {
        border-top: 2px solid #891313ff;
        margin: 3px 0;
      }
      .preview {
        width: 18px;
        height: 11px;
        margin-top: 5px;
        position: absolute;
        right: 69px;
      }
      .Logistics-query {
        position: absolute;
        right: 26px;
      }
      .Open-according-to {
        position: absolute;
        right: 20px;
        bottom: 59px;
        width: 89px;
        // height: 56px;
      }
      .text1 {
        color: rgba(0, 0, 0, 0.4);
      }
      .buttext {
        color: #2969ff;
      }
      .rowbut {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        margin: 14px 0;
        line-height: 20px;
      }

      .row {
        display: flex;
        font-size: 14px;
        margin: 14px 0;
        line-height: 20px;
      }
      .name {
        flex: 2;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .list:nth-child(4n) {
      margin-right: 0;
    }
  }
  .bottom {
    padding: 16px;
  }
}
</style>